import React, { useState, useEffect } from 'react';
import { Path } from 'router/constant';
import { Loader } from 'shared-components';
import { useLocation, useNavigate } from 'react-router-dom';
import { createInstallationService } from 'services/installationService';
import { toast } from 'react-toastify';
import { RootState } from 'redux-setup/store';
import { useAppSelector, useAppDispatch } from 'hooks/reduxHooks';
import { setCodeId } from 'redux-setup/slices/codeSlice';

export const AddGithubInstallation = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState<boolean>(true);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const installationId = queryParams.get('installation_id');
  const code = queryParams.get('code');
  const state = queryParams.get('state');
  const localState = localStorage.getItem('github_installation_state');
  const isStateValid = state === localState;
  const organizationId = useAppSelector(
    (state: RootState) => state.organization.id,
  );

  const addInstallation = async () => {
    try {
      if (code) {
        dispatch(setCodeId(code));
      }
      if (!installationId || !state) {
        console.error('Missing installation_id or state in query parameters.');
        toast.error('Installation failed please try again.');
        setLoading(false);
        return;
      }
      const response = await createInstallationService({
        OrganizationID: organizationId,
        ExternalID: installationId,
      });

      if (response.status === 200) {
        toast.success('GitHub app installed successfully');
        navigate(Path.DASHBOARD);
      } else {
        toast.error('Failed to add installation ID to organization');
        navigate(Path.SETTINGS);
      }
    } catch (error) {
      console.error('Error during GitHub installation:', error);
      toast.error('Network error please try again.');
      navigate(Path.SETTINGS);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isStateValid) {
      addInstallation();
    }
    if (!isStateValid) {
      localStorage.removeItem('github_installation_state');

      navigate(Path.SETTINGS);
      toast.error('Failed to install GitHub app - Invalid request');
    }
  }, [location.search, navigate]);

  return (
    <>
      <Loader loading={loading} />
    </>
  );
};
